import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {Slider} from '@/components/ui/slider'
import {Badge} from '../Badge'
import {FileTextIcon} from "lucide-react";
import {useCalculator, KPI_NASTUPY} from '@/contexts/CalculatorContext'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { InfoIcon } from "lucide-react"

export function ContractsSliderCard() {
    const {
        contracts,
        nastupy,
        setContracts,
        getContractsBonus,
        calculate3ContractProfit
    } = useCalculator()

    return (
        <Card className="w-full">
            <CardHeader>
                <div className="flex items-center gap-2">
                    <FileTextIcon className="w-5 h-5 text-primary"/>
                    <div>
                        <div className="flex items-center gap-2">
                            <CardTitle>3. složka</CardTitle>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>
                                        <InfoIcon className="w-4 h-4 text-muted-foreground" />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Nová rámcová aktivní smlouva je smlouva s minimálně jedním nástupem</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                        <p className="text-sm text-muted-foreground mt-1">
                            Počet nových aktivních rámcových smluv.
                        </p>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="text-center">
                    <div className="text-3xl font-bold text-primary">
                        {contracts} {contracts === 1 ? 'smlouva' : contracts < 5 ? 'smlouvy' : 'smluv'}
                    </div>
                    <div className="text-sm text-muted-foreground mt-1">
                        {nastupy >= KPI_NASTUPY ? (
                            <>
                                {contracts}× {getContractsBonus(contracts).toLocaleString()} Kč
                                = {calculate3ContractProfit().toLocaleString()} Kč
                            </>
                        ) : (
                            `KPI nesplněno (min. ${KPI_NASTUPY} nástupů)`
                        )}
                    </div>
                </div>
                <Slider
                    value={[contracts]}
                    onValueChange={(values) => setContracts(values[0])}
                    min={0}
                    max={8}
                    step={1}
                    className="w-full p-2"
                />
                <div className="flex justify-between text-sm text-muted-foreground">
                    <span>0 smluv</span>
                    <span>4+ smluv</span>
                </div>
                <div className="flex justify-between mt-4">
                    <Badge label="Jednorázově" variant="yellow"/>
                    <Badge label="Každých 6 měsíců" variant="blue"/>
                </div>
            </CardContent>
        </Card>
    )
} 